import { render, staticRenderFns } from "./GuestFooter.vue?vue&type=template&id=d74e9920&"
import script from "./GuestFooter.vue?vue&type=script&lang=ts&"
export * from "./GuestFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports